import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaWallet, FaBuilding, FaTasks, FaChartLine, FaListUl, FaFileAlt } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/transactions');
  };

  const features = [
    {
      title: "Financial Management",
      icon: <FaWallet className="feature-icon" />,
      description: "Track transactions, manage bank accounts, and monitor subscriptions all in one place.",
      link: "/transactions",
      color: "#42bdff"
    },
    {
      title: "Business Management",
      icon: <FaBuilding className="feature-icon" />,
      description: "Manage companies and track tasks efficiently.",
      link: "/companies",
      color: "#42bdff"
    },
    {
      title: "Task Tracking",
      icon: <FaTasks className="feature-icon" />,
      description: "Organize and prioritize your tasks with our intuitive task management system.",
      link: "/tasks",
      color: "#42bdff"
    },
    {
      title: "Financial Analytics",
      icon: <FaChartLine className="feature-icon" />,
      description: "Get insights into your financial data with detailed analytics and reports.",
      link: "/transactions",
      color: "#42bdff"
    },
    {
      title: "Wishlist",
      icon: <FaListUl className="feature-icon" />,
      description: "Keep track of your financial goals and wishlist items.",
      link: "/wishlist",
      color: "#42bdff"
    },
    {
      title: "Document Management",
      icon: <FaFileAlt className="feature-icon" />,
      description: "Organize and manage all your important documents in one secure location.",
      link: "/documents",
      color: "#42bdff"
    }
  ];

  return (
    <Container fluid className="home-container">
      {/* Hero Section */}
      <Row className="hero-section mb-5">
        <Col className="text-center">
          <h1 className="display-4 mb-4">Welcome to Anthesys</h1>
          <p className="lead mb-4">Your comprehensive financial and business management solution</p>
          <Button 
            variant="primary" 
            size="lg" 
            className="start-button"
            onClick={handleGetStarted}
          >
            Get Started
          </Button>
        </Col>
      </Row>

      {/* Features Grid */}
      <Row className="features-grid">
        {features.map((feature, index) => (
          <Col md={4} key={index} className="mb-4">
            <Link to={feature.link} className="text-decoration-none">
              <Card className="feature-card h-100">
                <Card.Body className="text-center">
                  <div className="icon-wrapper mb-3" style={{ color: feature.color }}>
                    {feature.icon}
                  </div>
                  <Card.Title>{feature.title}</Card.Title>
                  <Card.Text>{feature.description}</Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>

      {/* Quick Stats Section */}
      <Row className="quick-stats mt-5">
        <Col md={4}>
          <Card className="stat-card">
            <Card.Body>
              <h5>Total Balance</h5>
              <h3>€0.00</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="stat-card">
            <Card.Body>
              <h5>Active Tasks</h5>
              <h3>0</h3>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="stat-card">
            <Card.Body>
              <h5>Companies</h5>
              <h3>0</h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Home;

